import "%modules%/navbar/navbar";
import "%modules%/map/map";
import "%modules%/map-tabs/map-tabs";
import "%modules%/popup/popup";
import "%modules%/main-cities/main-cities";
import "%modules%/steps-list/steps-list";
import "%modules%/instrument-slider/instrument-slider";
import "%modules%/detail-rating/detail-rating";
import "%modules%/rating-slider/rating-slider";
import "%modules%/rating-feedback/rating-feedback";
import "%modules%/feedback/feedback";
import "%modules%/events/events";
import "%modules%/news-slider/news-slider";
